import React, { memo, useState } from "react"
import ClickAndCollectDrawer from "@components/ClickAndCollectDrawer"
import StoreDetails from "@components/ClickAndCollectDrawer/StoreDetails"
import StoreList from "@components/ClickAndCollectDrawer/StoreList"
import VariantSelect from "./VariantSelect"

export interface ProductFindInStoreProps {
  variants?: any[]
  onClose: VoidFunction
  setViewStore: (store: NormalisedStore | null) => void
  viewStore: NormalisedStore | null
  selectedVariant: any
  requiresProvider?: boolean
  drawerActive: boolean
}

const ProductFindInStore = ({
  variants,
  onClose,
  setViewStore,
  viewStore,
  selectedVariant,
  requiresProvider = true,
  drawerActive = false,
}: ProductFindInStoreProps) => {
  const [selectedSku, setSelectedSku] = useState<any>(selectedVariant?.sku)

  const productSkus = React.useMemo(() => {
    return [selectedSku]
  }, [selectedSku])

  return (
    <ClickAndCollectDrawer
      requiresProvider={requiresProvider}
      productSkus={productSkus}
      onClose={onClose}
      variants={variants}
      drawerActive={drawerActive}
    >
      {viewStore ? (
        <StoreDetails store={viewStore} onClose={() => setViewStore(null)} />
      ) : (
        <StoreList onSetViewStore={setViewStore} onClose={onClose}>
          <VariantSelect selectedSku={selectedSku} variants={variants} onSelectVariant={variant => setSelectedSku(variant)} />
        </StoreList>
      )}
    </ClickAndCollectDrawer>
  )
}

export default memo(ProductFindInStore)
